export const DEBOUNCE_TIME_500 = 500;
export const DEBOUNCE_TIME_300 = 300;
export const DEBOUNCE_TIME_50 = 50;

export const SELECTED_ACT_TEAM_VISITS_KEY = 'selectedActTeam-visits';
export const SELECTED_ACT_TEAM_MEDICATION_LOGISTICS_KEY = 'selectedActTeam-medication-logistics';

export const MILL_SEC_COEFF = 60 * 1000;
